import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i1 from '@xpo-ltl/ngx-ltl-core/popover';
import { XpoPopoverModule } from '@xpo-ltl/ngx-ltl-core/popover';

function XpoMessagingPopover_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtext(2, " Alert ");
    i0.ɵɵelementEnd();
} }
function XpoMessagingPopover_div_8_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵtext(2, " Warning ");
    i0.ɵɵelementEnd();
} }
function XpoMessagingPopover_div_8_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2, " Success ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "border-left-color": a0 }; };
function XpoMessagingPopover_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "p", 7);
    i0.ɵɵtemplate(2, XpoMessagingPopover_div_8_span_2_Template, 3, 0, "span", 8);
    i0.ɵɵtemplate(3, XpoMessagingPopover_div_8_span_3_Template, 3, 0, "span", 9);
    i0.ɵɵtemplate(4, XpoMessagingPopover_div_8_span_4_Template, 3, 0, "span", 10);
    i0.ɵɵelementStart(5, "span", 11);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "em", 12);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 13);
    i0.ɵɵtext(10);
    i0.ɵɵelementStart(11, "a", 14);
    i0.ɵɵtext(12, "\u2026Read More");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c0, ctx_r1.alertColor(item_r2.type)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r2.type == "alert");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.type == "warning");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r2.type == "success");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" - ", item_r2.app, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r2.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r2.body, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", item_r2.link, i0.ɵɵsanitizeUrl);
} }
class XpoMessagingPopover {
    alertColor(type) {
        let retColor = '$xpo-grey';
        switch (type) {
            case 'alert': {
                retColor = '#D50000';
                break;
            }
            case 'success': {
                retColor = '#00C853';
                break;
            }
            case 'warning': {
                retColor = '#FFBA00';
                break;
            }
        }
        return retColor;
    }
}
XpoMessagingPopover.ɵfac = function XpoMessagingPopover_Factory(t) { return new (t || XpoMessagingPopover)(); };
XpoMessagingPopover.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoMessagingPopover, selectors: [["xpo-messaging-popover"]], hostAttrs: [1, "xpo-MessagingPopover"], inputs: { messages: "messages" }, decls: 9, vars: 2, consts: [[1, "xpo-MessagingPopover-actionLink", 3, "xpoPopoverTriggerFor"], ["position", "below", "color", "accent", "hideCloseButton", "true", "caretPosition", "end"], ["notPop", "xpoPopover"], [1, "xpo-PopoverMenu-header"], [1, "xpo-MessagingPopover-content", "xpo-popoverMenu-content", "xpo-PopoverMenu-content--scrollable"], ["class", "xpo-PopoverMenu-item xpo-MessagingPopover-item", 3, "ngStyle", 4, "ngFor", "ngForOf"], [1, "xpo-PopoverMenu-item", "xpo-MessagingPopover-item", 3, "ngStyle"], [1, "xpo-MessagingPopover-status", "text--small"], ["class", "xpo-MessagingPopover-status--alert", 4, "ngIf"], ["class", "xpo-MessagingPopover-status--warning", 4, "ngIf"], ["class", "xpo-MessagingPopover-status--success", 4, "ngIf"], [1, "xpo-MessagingPopover-statusMessage"], [1, "xpo-MessagingPopover-title"], [1, "xpo-MessagingPopover-message", "text--small"], [1, "xpo-MessagingPopover-readMoreLink", 3, "href"], [1, "xpo-MessagingPopover-status--alert"], [1, "xpo-MessagingPopover-statusIcon", "fas", "fa-exclamation-circle"], [1, "xpo-MessagingPopover-status--warning"], [1, "xpo-MessagingPopover-statusIcon", "fas", "fa-exclamation-triangle"], [1, "xpo-MessagingPopover-status--success"], [1, "xpo-MessagingPopover-statusIcon", "fas", "fa-check-circle"]], template: function XpoMessagingPopover_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵelementStart(1, "mat-icon");
        i0.ɵɵtext(2, "notifications");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "xpo-popover", 1, 2);
        i0.ɵɵelementStart(5, "xpo-popover-title", 3);
        i0.ɵɵtext(6, "Notifications");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵtemplate(8, XpoMessagingPopover_div_8_Template, 13, 10, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(4);
        i0.ɵɵproperty("xpoPopoverTriggerFor", _r0);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.messages);
    } }, directives: [i1.XpoPopoverTrigger, i2.MatIcon, i1.XpoPopover, i1.XpoPopoverTitle, i3.NgForOf, i3.NgStyle, i3.NgIf], styles: [".flex--stretch{flex:1}.xpo-MessagingPopover-actionLink:hover{cursor:pointer}.xpo-MessagingPopover-content{max-height:330px}.xpo-MessagingPopover-item{border-left:4px solid}.xpo-MessagingPopover-status{margin:0 0 4px}.xpo-MessagingPopover-status--alert,.xpo-MessagingPopover-status--warning,.xpo-MessagingPopover-status--success{font-weight:500}.xpo-MessagingPopover-status--alert{color:#d50000}.xpo-MessagingPopover-status--warning{color:#ffba00}.xpo-MessagingPopover-status--success{color:#11a63b}.xpo-MessagingPopover-statusIcon{font-size:1.143rem;vertical-align:text-bottom}.xpo-MessagingPopover-statusMessage{color:#9b9b9b;font-weight:400}.xpo-MessagingPopover-title{display:block;font-style:normal;font-weight:500;margin-bottom:4px}.xpo-MessagingPopover-message{color:#9b9b9b;margin:0}.xpo-MessagingPopover-readMoreLink{color:#0868ac;text-decoration:none}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoMessagingPopover, [{
        type: Component,
        args: [{
                selector: 'xpo-messaging-popover',
                templateUrl: './messaging-popover.html',
                styleUrls: ['./messaging-popover.scss'],
                host: {
                    class: 'xpo-MessagingPopover',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, { messages: [{
            type: Input
        }] }); })();

class XpoMessagingPopoverModule {
    constructor() { }
}
XpoMessagingPopoverModule.ɵfac = function XpoMessagingPopoverModule_Factory(t) { return new (t || XpoMessagingPopoverModule)(); };
XpoMessagingPopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoMessagingPopoverModule });
XpoMessagingPopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, XpoPopoverModule, MatButtonModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoMessagingPopoverModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoPopoverModule, MatButtonModule, MatIconModule],
                declarations: [XpoMessagingPopover],
                exports: [XpoMessagingPopover],
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoMessagingPopoverModule, { declarations: [XpoMessagingPopover], imports: [CommonModule, XpoPopoverModule, MatButtonModule, MatIconModule], exports: [XpoMessagingPopover] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoMessagingPopover, XpoMessagingPopoverModule };
